import { toast } from "react-toastify";

const swal = async (error, text) => {
  switch (error) {
    case "success":
      toast.success(text);
      break;
    case "info":
      toast.info(text);
      break;
    case "warning":
      toast.warn(text);
      break;
    default:
      toast.error(text);
      break;
  }
};
export default swal;
